import React from 'react'
import { Box, BoxProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'

// Die eine Stelle, an der das Kartenaussehen definiert ist: zartblaue Fläche mit dezenter Umrandung
// statt Schatten. Es ist derselbe Ton wie hinter den Tabs (`lightBackground`) — die Karten sollen
// sich vom weißen Tab-Hintergrund abheben, aber nicht kräftiger wirken als der Seitenrahmen. Die
// Trennung leistet die Umrandung. Jeder Wert lässt sich per Prop überschreiben; Abstände nach außen
// (`mb`) gehören an die Aufrufstelle, nicht hierher.
const Card = ({ children, ...rest }: BoxProps): JSX.Element => {
	const theme = useTheme()
	return (
		<Box
			display="flex"
			flexDirection="column"
			width="100%"
			p="1.5rem"
			bgcolor={theme.customColors.lightBackground}
			border={1}
			borderColor="divider"
			borderRadius="0.75rem"
			overflow="hidden"
			{...rest}
		>
			{children}
		</Box>
	)
}

export default React.memo(Card)
